'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.securityGroup.configure.kubernetes', [
  require('./wizard/backend.controller.js').name,
  require('./wizard/rules.controller.js').name,
  require('./wizard/tls.controller.js').name,
  require('./wizard/upsert.controller.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/kubernetes/src/securityGroup/configure/configure.kubernetes.module.js